import type { ReactNode } from "react";

export function SubmissionsListToolbar({ children }: { children: ReactNode }) {
  return (
    <div className="flex flex-wrap items-center gap-2 border-b border-slate-100 bg-slate-50/50 px-4 py-3">
      {children}
    </div>
  );
}
